import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaProgressBarComponent from './VaProgressBar.vue'

export const VaProgressBar = withConfigTransport(VaProgressBarComponent)
